import React from "react";
import { Link } from "react-router-dom";
import Sidebar from "../../partials/aside/Sidebar";
import TitleBar from "../../partials/content/TitleBar";
import helpersNumber from "../../../helpers/numbers";
import StatusCampaignSimple from "./StatusCampaignSimple";
import campaigns from "./campaigns";

export default function AllCampaigns() {
  const generateTagCampaigns = () => {
    return campaigns.map((campaign, index) => {
      let textStateCampaign =
        StatusCampaignSimple.statusCampaignString()[campaign.status];

      let tagClass;
      switch (campaign.status) {
        case StatusCampaignSimple.statusCampaign.PENDING_TO_START_DATE:
          tagClass = "warning";
          break;
        case StatusCampaignSimple.statusCampaign.ACTIVE:
          tagClass = "success";
          break;
        case StatusCampaignSimple.statusCampaign.FINISHED:
          tagClass = "info";
          break;
        case StatusCampaignSimple.statusCampaign.CANCELED:
          tagClass = "danger";
          break;
      }
      const urlCampaign = "";

      return (
        <tr key={index}>
          <td>{helpersNumber.toPersianNum(index + 1)}</td>
          <td>{helpersNumber.toPersianNum(campaign.id)}</td>
          <td>{campaign.name}</td>
          <td>{campaign.category}</td>
          <td>{campaign.type}</td>
          <td dir="ltr">{helpersNumber.toPersianNum(campaign.created_at)}</td>
          <td dir="ltr">{helpersNumber.toPersianNum(campaign.start_date)}</td>
          <td dir="ltr">{helpersNumber.toPersianNum(campaign.end_date)}</td>
          <td>
            <div className="text-center">
              <span className={`badge badge-${tagClass} `}>
                {textStateCampaign}
              </span>
            </div>
          </td>
          <td>
            <div>
              <span className="pl-2">
                <Link
                  className="btn btn-info  "
                  to={`/campaigns/${campaign.id}`}
                >
                  <i className="fa fa-info"></i>
                </Link>
              </span>
            </div>
          </td>
        </tr>
      );
    });
  };

  return (
    <>
      <Sidebar activeItem="all-campaigns" />

      <div className="content-wrapper">
        <TitleBar title="کمپین ها" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div className="table-responsive ">
                <table className="table table-hilite tbl-td-white-space">
                  <thead>
                    <tr>
                      <td>#</td>
                      <td>شماره کمپین</td>
                      <td>نام کمپین</td>
                      <td>نام گروه نمایش دهنده</td>
                      <td>نوع کمپین</td>
                      <td>تاریخ ایجاد</td>
                      <td>تاریخ شروع</td>
                      <td>تاریخ پایان</td>
                      <td>وضعیت</td>
                      <td>عملیات</td>
                    </tr>
                  </thead>
                  <tbody>{generateTagCampaigns()}</tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
